module.exports = __webpack_public_path__ + "img/hr-car-mask-3.774af52c.png";